import { render, staticRenderFns } from "./AllPlaces.vue?vue&type=template&id=438117f4&"
import script from "./AllPlaces.vue?vue&type=script&lang=js&"
export * from "./AllPlaces.vue?vue&type=script&lang=js&"
import style0 from "./AllPlaces.vue?vue&type=style&index=0&id=438117f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports